import { Component, h, Host, Prop, Method } from "@stencil/core";
import Splide, {Options} from "@splidejs/splide";

@Component({
	tag: "smart-carousel",
	styleUrl: "smart-carousel.scss",
	shadow: false,
})
export class SmartCarousel {
	@Prop() carouselId = "smart-carousel";
	@Prop() autoMount = true;
  @Prop() splideOptions: Options = {autoWidth: true, arrows: true};
  private splideInstance: Splide;

	@Method()
  async smartMount() {
  	this.splideInstance = new Splide(`#${this.carouselId}`, this.splideOptions).mount();
  }
	
	@Method()
	async smartRefresh() {
  	this.splideInstance.refresh();
	}
	
	@Method()
	async smartDestroy() {
  	this.splideInstance.destroy();
	}

	componentDidLoad() {
  	if(this.autoMount) this.splideInstance = new Splide(`#${this.carouselId}`, this.splideOptions).mount();
	}

	render() {
  	return (
  		<Host id={this.carouselId} class="splide" role="group">
  			<div class="splide__track">
  				<div class="splide__list">
  					<slot></slot>
  				</div>
  			</div>
  		</Host>
  	);
	}

}
